<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'dashboard/composables/store';
import PageLayout from 'dashboard/components-next/pilot/PageLayout.vue';
import AssistantPlayground from 'dashboard/components-next/pilot/assistant/AssistantPlayground.vue';

const route = useRoute();
const store = useStore();

const assistantId = computed(() => Number(route.params.assistantId));

onMounted(() => {
  // 加载助手列表，以便助手切换器能显示数据
  store.dispatch('pilotAssistants/get');
});
</script>

<template>
  <PageLayout
    show-assistant-switcher
    :show-pagination-footer="false"
    :show-know-more="false"
    class="h-full"
  >
    <template #body>
      <div class="flex flex-col h-full">
        <AssistantPlayground :assistant-id="assistantId" class="bg-n-solid-1" />
      </div>
    </template>
  </PageLayout>
</template>
